import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import MealDetailShimmer from "../components/Preloader/MealDetailShimmer";
import {
  getExtraItems,
  getMealDetailById,
} from "../redux/thunks/mealsetupThunk";
import ImagePreview from "../components/ui/ImagePreview";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { decryptId } from "../utils/urlCrypto";
const dayLabels = {
  monday: "M",
  tuesday: "Tu",
  wednesday: "W",
  thursday: "Th",
  friday: "F",
  saturday: "Sa",
  sunday: "Su",
};

const Mealdetail = () => {
  const navigate = useNavigate();
  const { mealId } = useParams();
  const meal_id = decryptId(mealId);
  const dispatch = useDispatch();
  const [getImgs, setGetImgs] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [availability, setAvailability] = useState([]);
  const [trialPlan, setTrialPlan] = useState("");
  const [weeklyPlans, setWeeklyPlans] = useState([]);
  const [montlyPlan, setMonthlyPlan] = useState([]);
  const [lunchcutOff, setLunchcutOff] = useState("");
  const [dinnercutOff, setDinnercutOff] = useState("");
  const [extraItemsMap, setExtraItemsMap] = useState({});
  const [mealExtraIds, setMealExtraIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const currencySymbol = localStorage.getItem("currency");

  useEffect(() => {
    dispatch(getExtraItems())
      .unwrap()
      .then((res) => { 
        if (res.data?.extra_items?.length) {
          const map = {};

          res.data.extra_items.forEach((item) => {
            map[item.id] = {
              name: item.name,
              price: item.amounts,
            };
          });

          setExtraItemsMap(map);
          // console.log("Extra Items Map:", map);
        }
      });
  }, [dispatch]);

  useEffect(() => {
    const payload = {
      meal_id: meal_id,
    };
    dispatch(getMealDetailById(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res is :", res.data);
        const getTitle = res.data?.meal_name;
        setTitle(getTitle);

        const getDescp = res.data?.meal_description;
        setDescription(getDescp);

        const getTrial = res.data?.trial_serving_cost;
        setTrialPlan(getTrial);

        if (res.data?.weekly_plans?.length) {
          const weeklyFormatted = res.data.weekly_plans.map((plan) => ({
            id: plan.id,
            price: plan.plan_amount,
            days: plan.order_count,
          }));

          setWeeklyPlans(weeklyFormatted);
          // console.log("Weekly plans formatted:", weeklyFormatted);
        } else {
          setWeeklyPlans([]); // clear if no plans
        }

        if (res.data?.monthly_plans?.length) {
          const monthlyFormatted = res.data.monthly_plans.map((plan) => ({
            id: plan.id,
            price: plan.plan_amount,
            days: plan.order_count,
          }));

          setMonthlyPlan(monthlyFormatted);
          // console.log("Weekly plans formatted:", monthlyFormatted);
        } else {
          setMonthlyPlan([]);
        }

        const getLunchCutoff = res.data?.lunch_cutoff_time;
        setLunchcutOff(getLunchCutoff);

        const getDinnerCutoff = res.data?.dinner_cutoff_time;
        setDinnercutOff(getDinnerCutoff);

        setAvailability(res.data?.availability_data || []);

        if (res.data?.meal_other_images?.length) {
          const ImagesData = res.data.meal_other_images.map((img) => {
            return {
              id: img.id,
              name: img.name,
              preview: img.image_url,
              isCover: img.is_cover_image === 1,
            };
          });

          const coverIndex = ImagesData.findIndex((img) => img.isCover);
          if (coverIndex > 0) {
            const coverImage = ImagesData.splice(coverIndex, 1)[0];
            ImagesData.unshift(coverImage);
          }
          setGetImgs(ImagesData);
        }
        const getExtraIds = res.data?.extra_item_ids || [];
        setMealExtraIds(getExtraIds);
        setLoading(false);
      });
  }, [dispatch]);
  if (loading) {
    return <MealDetailShimmer />;
  }
  return (
    <section className="relative max-w-7xl mx-auto px-4 py-6 max-h-screen">
      <DecorativeSquares />
      <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
        {/* Back Button – Left */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center p-2 rounded-full hover:bg-gray-100 transition"
        >
          <FaArrowLeft className="text-lg" />
        </button>

        {/* Title – Center */}
        <h1 className="mx-auto text-[#191919] font-bold text-base md:text-lg lg:text-xl">
          View Meal Plan
        </h1>
      </div>
      <div className="w-full max-w-7xl bg-transparent md:bg-white rounded-none md:rounded-2xl  p-2 md:p-6 space-y-8">
        {/* PHOTOS */}
        <div className="border border-gray-200 rounded-xl p-4">
          <h2 className="text-base font-semibold text-[#191919] mb-4">
            Meal Photographs
          </h2>
          <div className="flex flex-wrap gap-3">
            {getImgs.map((img, i) => (
              <ImagePreview
                key={`${img.id}-${i}`} // ensures unique key
                src={img.preview}
                alt={img.name || `dish-${i}`}
                className={`h-16 w-16 md:h-24 md:w-24 rounded-lg object-cover ${
                  i === 0 ? "ring-4 ring-[#FF6943] " : ""
                }`}
              />
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* TITLE + PRICE */}
          <div className="border border-gray-200 rounded-xl p-4">
            <h1 className="text-lg font-semibold text-[#191919]">{title}</h1>
            <p className="text-lg font-semibold text-[#FF6943] mt-1">
              {currencySymbol} {trialPlan}
            </p>
            <p className="text-sm text-[#828282] mt-3 leading-relaxed">
              {description}
            </p>
          </div>

          {/* DAYS + MEAL TYPE */}
          <div className="border border-gray-200 rounded-xl p-4">
            <h2 className="text-base font-semibold text-[#191919] mb-3">
              Days of operation
            </h2>

            <div className="flex gap-2 mb-2">
              <div className="flex gap-2 mb-2">
                {availability?.map((day) => {
                  const { isLunch, isDinner, isActive } = day;

                  let bgStyle = {};
                  let textColor = "text-white";

                  if (isActive && isLunch && isDinner) {
                    // 🔺 Diagonal split (Lunch + Dinner)
                    bgStyle = {
                      background:
                        "linear-gradient(135deg, #B472FF 50%, #FF6943 50%)",
                    };
                  } else if (isActive && isLunch) {
                    // 🟣 Only Lunch
                    bgStyle = { backgroundColor: "#B472FF" };
                  } else if (isActive && isDinner) {
                    // 🟠 Only Dinner
                    bgStyle = { backgroundColor: "#FF6943" };
                  } else {
                    // ⚪ Not Active
                    bgStyle = { backgroundColor: "#f3f4f6" };
                    textColor = "text-[#303030]";
                  }

                  return (
                    <span
                      key={day.key}
                      style={bgStyle}
                      className={`h-6 w-6 md:h-8 md:w-8 rounded-md flex items-center justify-center text-sm font-semibold ${textColor}`}
                      title={`Lunch: ${isLunch ? "Yes" : "No"}, Dinner: ${
                        isDinner ? "Yes" : "No"
                      }`}
                    >
                      {dayLabels[day.key]}
                    </span>
                  );
                })}
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex items-center gap-2">
                <span className="h-3 w-3 rounded-full bg-[#B472FF]" />
                <span className="text-sm">Lunch</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="h-3 w-3 rounded-full bg-[#FF6943]" />
                <span className="text-sm">Dinner</span>
              </div>
            </div>
          </div>

          {/* Cutoff Time */}
          <div className="border border-gray-200 rounded-xl p-4">
            <h2 className="text-base font-semibold text-[#191919] mb-4">
              Cutoff Time
            </h2>
            <div className="flex gap-6">
              <div>
                <p className="text-sm mb-1">Lunch</p>
                <div className="bg-gray-100 rounded-lg px-4 py-2 text-sm text-center">
                  {lunchcutOff}
                </div>
              </div>
              <div>
                <p className="text-sm mb-1">Dinner</p>
                <div className="bg-gray-100 rounded-lg px-4 py-2 text-sm text-center">
                  {dinnercutOff}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PRICING */}
        <div>
          <h2 className="text-base font-semibold text-[#191919] mb-4">
            Meal Plan Pricing
          </h2>
          <fieldset className="border rounded-xl p-4">
            <legend className="px-2 text-sm text-gray-600">Trial</legend>
            <div className="bg-gray-100 rounded-lg p-3 text-sm flex justify-between items-center">
              <span>Trial (1 Meal)</span>
              <strong>
                {currencySymbol}
                {trialPlan}
              </strong>
            </div>
          </fieldset>
          <div className="grid md:grid-cols-2 gap-4 mt-4">
            {/* Weekly */}
            <fieldset className="border rounded-xl p-4">
              <legend className="px-2 text-sm text-gray-600">Weekly</legend>

              <div className="space-y-2 text-sm">
                {weeklyPlans?.length > 0 ? (
                  weeklyPlans.map((plan) => (
                    <div
                      key={plan.id}
                      className="bg-gray-100 rounded-lg p-3 flex justify-between items-center"
                    >
                      <span>{plan.days} Meals</span>
                      <strong>
                        {currencySymbol}
                        {plan.price}
                      </strong>
                    </div>
                  ))
                ) : (
                  <div className="text-gray-500">No weekly plans available</div>
                )}
              </div>
            </fieldset>
            {/* Monthly */}
            <fieldset className="border rounded-xl p-4 ">
              <legend className="px-2 text-sm text-gray-600">Monthly</legend>
              <div className="space-y-2 text-sm">
                {montlyPlan?.length > 0 ? (
                  montlyPlan.map((plan) => (
                    <div
                      key={plan.id}
                      className="bg-gray-100 rounded-lg p-3 flex justify-between items-center"
                    >
                      <span>{plan.days} Meals</span>
                      <strong>
                        {currencySymbol}
                        {plan.price}
                      </strong>
                    </div>
                  ))
                ) : (
                  <div className="text-gray-500">No weekly plans available</div>
                )}
              </div>
            </fieldset>
          </div>
        </div>

        {/* CUTOFF */}
        {/* <div>
          <h2 className="text-base font-semibold text-[#191919] mb-4">
            Cutoff Time Muskan
          </h2>
          <div className="flex gap-6">
            <div>
              <p className="text-sm mb-1">Lunch</p>
              <div className="bg-gray-100 rounded-lg px-4 py-2 text-sm text-center">
                {lunchcutOff}
              </div>
            </div>
            <div>
              <p className="text-sm mb-1">Dinner</p>
              <div className="bg-gray-100 rounded-lg px-4 py-2 text-sm text-center">
                {dinnercutOff}
              </div>
            </div>
          </div>
        </div> */}

        {/* EXTRAS */}
        <div>
          <h2 className="text-base font-semibold text-[#191919] md:mb-2">
            Extra items
          </h2>
          <div className="flex flex-wrap gap-2 mb-4 mt-2">
            {mealExtraIds.length > 0 ? (
              mealExtraIds.map((id) => {
                const item = extraItemsMap[id];
                if (!item) return null;

                return (
                  <div
                    key={id}
                    className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FFF4F1] border border-[#FFD6CC] text-sm"
                  >
                    <span className="text-[#191919] font-medium">
                      {item.name}
                    </span>
                    <span className="px-2 py-0.5 rounded-full bg-[#FF6943] text-white text-xs font-semibold">
                      {currencySymbol}
                      {item.price}
                    </span>
                  </div>
                );
              })
            ) : (
              <span className="text-sm text-gray-400">
                No extra items added
              </span>
            )}
          </div>
        </div>
      </div>
      {/* <PrimaryBtn btnName="test" clickEvent={onBack} /> */}
    </section>
  );
};

export default Mealdetail;
